import { render, staticRenderFns } from "./CustomerInfoDetail.vue?vue&type=template&id=60779bab&scoped=true&"
import script from "./CustomerInfoDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoDetail.vue?vue&type=style&index=0&id=60779bab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60779bab",
  null
  
)

export default component.exports